export default __webpack_public_path__ + "static/doublo-ML-cdaf88681b06228a636363c566d7d098.gif";